<app-fiche-consultation [dataColumnsAr]="dataColumnsAr" [dataColumnsEn]="dataColumnsEn" [dataColumns]="dataColumns"

                        [data]="data" [label]="label"
                        [labels]="labels"
                        [langue]="getlang()"
>


</app-fiche-consultation>
<br>


<app-fiche-consultation [dataColumnsAr]="dataColumnsAr2" [dataColumnsEn]="dataColumnsEn2" [dataColumns]="dataColumns2"

                        [data]="data" [label]="label2"
                        [labels]="lables2"
                        [langue]="getlang()"
>


</app-fiche-consultation>

